import React, {FC} from 'react';

import {ActionVisibility} from 'entities/metadata';

import {EFormMode} from '../../form-types';
import {useFormElementsAvailability} from '../../hooks/check-form-elements-availability.hook';
import {ButtonEditForm} from '../button-edit-form/button-edit-form';
import {ButtonSave} from '../button-save';

interface IButtonSaveOrEditFormOwnProps {
    entityName?: any;
    buttonType?: any;
    formMode?: EFormMode;
    action?: any;
}

interface IButtonSaveOrEditFormProps extends IButtonSaveOrEditFormOwnProps {}

export const ButtonSaveOrEditForm: FC<IButtonSaveOrEditFormProps> = ({
    formMode, buttonType, action, ...props
}: IButtonSaveOrEditFormProps) => {
    const {currentActionsVisibleState} = useFormElementsAvailability(
        formMode || EFormMode.REPRESENTATION,
        action.modalEntityName,
    );
    if ((formMode === 'create' && [ActionVisibility.CREATION, ActionVisibility.DEFAULT]
        .includes(currentActionsVisibleState))
        || (formMode === 'edit' && currentActionsVisibleState === ActionVisibility.EDITING)) {
        return (
            <ButtonSave
                actionTitle="Сохранить"
                buttonType={buttonType || 'primary'}
                {...props}
            />
        );
    }
    if (((formMode === 'edit' && currentActionsVisibleState === ActionVisibility.DEFAULT)
        || (formMode === 'edit' && currentActionsVisibleState === ActionVisibility.VIEWING))
        && currentActionsVisibleState !== ActionVisibility.EDITING) {
        return (
            <ButtonEditForm
                entityName={action.modalEntityName}
                actionTitle="Редактировать"
                {...props}
            />
        );
    }
    return null;
};
